import * as React from 'react'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { blurbText } from '../..'

export function InfoBlurb() {
  return (
    <Box mt={0} mb={2}>
      <Alert severity="info" sx={{ alignItems: 'flex-start' }}>
        <Typography variant="body2">{blurbText}</Typography>
      </Alert>
    </Box>
  )
}
